export default {"src":"/_next/static/media/checkmark.cfdfb5d0.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};